import React, { ReactNode } from 'react';

type BadgeLabelProps = {
    label: string | ReactNode;
    children: ReactNode;
    parentClassName?: string
};

const BadgeLabel: React.FC<BadgeLabelProps> = ({ label, children, parentClassName = '' }) => {
    return (
        <div className={`flex flex-col gap-sm justify-between bg-white py-2 pl-4 pr-10 rounded-md ${parentClassName}`}>
            <p className='text-gray-400 text-xs'>
                {label}
            </p>
            <p className='text-gray-700 text-xs'>
                {children}
            </p>
        </div>
    );
};

export default BadgeLabel;

